module.exports = "/build/web/svg/logo-uw-schilderwerk.080c8a0573110c87d92b1fdc01c346be.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/logo-uw-schilderwerk.svg
// module id = 145
// module chunks = 11